import(/* webpackMode: "eager" */ "/codebuild/output/src1293906955/src/openmenu-frontend/app/checkout/page.jsx");
